const getLocalizedData = require('../src/utils/getLocalizedData');
const translations = require('../src/static/translations');

function getStringTranslations(locale) {
  return getLocalizedData(translations, locale);
}
module.exports = getStringTranslations;
